// Backend API endpoints
export const ApiBaseUrl = (<any>window)['ApiBaseUrl']

export const LoginUrl = `${ApiBaseUrl}/v0/login`
export const LogoutUrl = `${ApiBaseUrl}/v0/logout`
export const CriteriaUrl = `${ApiBaseUrl}/v0/criteria`
export const DataUrl = `${ApiBaseUrl}/v0/data`
export const UsersUrl = `${ApiBaseUrl}/v0/users`
export const AcceptInvitationUrl = `${ApiBaseUrl}/v0/auth/accept-invitation`
export const ForgotPasswordUrl = `${ApiBaseUrl}/v0/auth/forgot-password`
export const ResetPasswordUrl = `${ApiBaseUrl}/v0/auth/reset-password`
export const AuthMeUrl = `${ApiBaseUrl}/v0/auth/me`
export const AuthProvidersUrl = `${ApiBaseUrl}/v0/auth/providers`
export const SlackLoginUrl = `${ApiBaseUrl}/v0/auth/slack/login`
export const PreferencesUrl = `${ApiBaseUrl}/v0/preferences`
export const FbApiStatsUrl = `${ApiBaseUrl}/v0/fb-api-stats`
export const JobsUrl = `${ApiBaseUrl}/v0/jobs`
export const NotFoundCampaignsUrl = `${ApiBaseUrl}/v0/not-found-campaigns`
